{
  "Financial Instruments": "Finansiella instrument",
  "Payments & Cash Management": "Betalningar och penninghantering",
  "Securities & Custody Services": "Värdepapper och depåtjänster",
  "Trade & Receivables Finance": "Handel och fordringar",
  "Corporate Analysis & Credits": "Företagsanalys och krediter",
  "Financing & Loans": "Finansiering och lån",
  "Pensions & Insurances": "Pension och försäkring",
  "Risk & Profitability": "Risk och lönsamhet",
  "Savings & Investments": "Sparande och investeringar",
  "Software Development": "Mjukvaruutveckling",
  "Quality Assurance": "Kvalitetssäkring",
  "Automation": "Automatisering",
  "Blockchain": "Blockchain",
  "Social Networks": "Sociala nätverk",
  "Web Development": "Webbutveckling",
  "Mobile Development": "Mobilutveckling",
  "Robotics": "Robotik",
  "DevOps": "DevOps",
  "IOT": "IOT",
  "Languages": "Språk",
  "Team Management & Development": "Gruppledarskap och grupputveckling",
  "Strategic": "Strategisk",
  "Organizational Leadership": "Organisationsledarskap",
  "Executive Leadership": "Verkställande ledarskap",
  "Project Management": "Projektledning",
  "Coaching & Mentoring": "Coachning och mentorskap",
  "People Management": "Personalledning",
  "Personal Leadership": "Personligt ledarskap",
  "Negotiation": "Förhandling",
  "Conflict Resolution": "Konflikthantering",
  "Directives": "Direktiv",
  "Interpersonal Skills": "Social förmåga",
  "Collaboration": "Samarbete",
  "Self Development": "Självutveckling",
  "Career Development": "Karriärutveckling",
  "Time Management": "Tidsplanering",
  "Wellness": "Hälsa",
  "Resilience": "Motståndskraft",
  "Feedback": "Återkoppling",
  "Agile": "Agilt",
  "Service Design": "Tjänstedesign",
  "Business Strategy": "Affärsstrategi",
  "Business Analytics": "Affärsanalys",
  "Change Management": "Förändringsarbete",
  "Digital Literacy": "Digital kompetens",
  "Growth & Acquisitions": "Tillväxt och förvärv",
  "Lean Concept": "Leankoncept",
  "Legal": "Juridik",
  "Organizational Development": "Organisatorisk utveckling",
  "Financial Fundamentals": "Finansiella grundkunskaper",
  "Global Mandatory Training": "Global obligatorisk utbildning",
  "License Compliance": "Licensefterlevnad",
  "Regulatory": "Reglerande",
  "Our Brand": "Vårt varumärke",
  "Our Health & Work Environment": "Vår hälsa och arbetsmiljö",
  "Our Sustainability": "Vår hållbarhet",
  "Our Vision & Values": "Vår vision och värderingar",
  "Our Compensation & Benefits": "Vår kompensation och förmåner",
  "Our Diversity & Inclusion": "Vår mångfald och integration",
  "Get Started": "Komma igång",
  "Service & Sales Methodologies": "Service och försäljningsmetoder",
  "Strategy": "Strategi",
  "Customer Service": "Kundservice",
  "Advisory": "Rådgivning",
  "Service & Sales Research": "Service- och försäljningsforskning",
  "Service & Sales Planning": "Service- och försäljningsplanering",
  "Opportunity Management": "Möjlighetshantering",
  "Portfolio Management": "Portföljhantering",
  "Relationship Management": "Relationshantering",
  "Customer Success": "Kundframgång",
  "Cyber Security": "Cybersäkerhet",
  "IT Security": "IT-säkerhet",
  "Physical Security": "Fysisk säkerhet",
  "Risk Management": "Riskhantering",
  "Operational Risk": "Operativ risk",
  "Security Certifications": "Säkerhetscertifieringar",
  "Security Audits": "Säkerhetsgranskningar",
  "Security Testing": "Säkerhetstester",
  "Security Processes": "Säkerhetsprocesser",
  "Compliance": "Efterlevnad",
  "Risk Assessment": "Riskbedömning",
  "Machine Learning/AI": "Maskinlärning / AI",
  "Data Structures & Algorithms": "Datastrukturer och algoritmer",
  "Data Analysis": "Dataanalys",
  "Data Science": "Data Science",
  "Data Governance": "Datastyrning",
  "Data Modelling": "Datamodellering",
  "Data Visualisation & Dashboards": "Datavisualisering och instrumentpaneler",
  "Predictive Analytics": "Prediktiv analys",
  "Big Data": "Stordata",
  "Processes": "Processer",
  "Process & Automation": "Process och automatisering",
  "Service Centres": "Servicecenter",
  "Logistics": "Logistik",
  "Administration": "Administrering",
  "Corporate Sustainability": "Företagshållbarhet",
  "Human Sustainability": "Mänsklig hållbarhet",
  "Social Sustainability": "Social hållbarhet",
  "Economic Sustainability": "Ekonomisk hållbarhet",
  "Environmental Sustainability": "Miljömässig hållbarhet",
  "Development Sustainability": "Hållbar utveckling",
  "Economics": "Ekonomi",
  "Investments": "Investeringar",
  "Tax": "Skatt",
  "Securities": "Värdepapper",
  "International": "Internationell",
  "Insurance": "Försäkring",
  "Payment Processing": "Betalningshantering",
  "Continuous Learning": "Kontinuerligt lärande",
  "Human Resources Management": "Personalförvaltning",
  "Diversity & Inclusion": "Mångfald och integration",
  "Employee Onboarding": "Onboarding av anställda",
  "Rights & Regulations": "Rättigheter och förordningar",
  "People & Culture Strategy": "Människor och kulturstrategi",
  "Marketing Strategy": "Marknadsföringsstrategi",
  "Marketing Analytics": "Marknadsföringsanalys",
  "Communication": "Kommunikation",
  "Communication Strategy": "Kommunikationsstrategi",
  "Branding": "Varumärkesbyggande",
  "Functional Skills": "Funktionella färdigheter",
  "Tools & Technologies": "Verktyg och teknologier",
  "E-Safety": "E-säkerhet",
  "Connecting & Collaborating": "Anknytning och samarbete",
  "Content Creation": "Contentskapande",
  "Communication and Netiquette": "Kommunikation och netikett",
  "Cloud": "Molnet",
  "Networking": "Nätverk",
  "Operating Systems": "Operativsystem",
  "Support & Operations": "Support och drift",
  "Database Administration": "Databasadministration",
  "Server Management": "Serverhantering",
  "Digital Design": "Digital design",
  "User Experience Design": "Design för användarupplevelse",
  "Graphic Design": "Grafisk design",
  "Industrial Design": "Industridesign",
  "Design Methodology": "Designmetodik",
  "Audio Design": "Ljuddesign",
  "Medical Engineering": "Medicinsk teknik",
  "Biological Engineering": "Bioteknik",
  "Chemical Engineering": "Kemiteknik",
  "Electrical Engineering": "Ellära",
  "Mechanical Engineering": "Maskinteknik",
  "Physics": "Fysik",
  "Astronomy": "Astronomi",
  "Environmental Engineering": "Miljöteknik",
  "Research Methodologies": "Forskningsmetodik"
}
